import { LocationNumbersService } from "../../../services"

const fetchRegulatoryBundles = async function(_, payload) {
  try {
    const { data } = await LocationNumbersService.getRegulatoryBundles(
      payload
    )

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default fetchRegulatoryBundles
